module.exports = __webpack_public_path__ + "img/Feature.d3613ace.jpg";